export const HEADER_HEIGHT = 48;

export const HANACARD_TAB_HEIGHT = 48;